<button class="button-small" [class]="'button-small button-small--' + buttonType()" [type]="nativeType()"
  [disabled]="disabled()" [attr.aria-label]="ariaLabel()" (click)="emitPressed()">
  @if (preIcon()) {
  <app-icon [icon]="preIcon()!" [color]="iconColor() ?? 'currentColor'" [width]="iconWidth()" [height]="iconHeight()" />
  }

  <span class="button-small__label"><ng-content></ng-content></span>

  @if (postIcon()) {
  <app-icon [icon]="postIcon()!" [color]="iconColor() ?? 'currentColor'" [width]="iconWidth()" [height]="iconHeight()" />
  }
</button>